/**
 * feedback-helpers.ts — Nhãn, kiểu dữ liệu và hàm thuần cho Platform → Góp ý của khách.
 * Backend: ecdp_backend_source/src/modules/platform/platform-feedback-routes.ts
 */
export type FeedbackStatus = 'new' | 'reviewing' | 'planned' | 'fixed' | 'rejected'
export type FeedbackKind = 'bug' | 'idea' | 'feature' | 'other'

export interface FeedbackItem {
  id: string
  orgId: string
  orgName: string
  userId: string
  userEmail: string
  userName: string
  role: string
  impersonatedBy: string | null
  type: FeedbackKind
  message: string
  page: string
  withDiagnostics: boolean
  userAgent: string
  viewport: string
  appVersion: string
  errors: Array<{ message: string; source: string; at: string }>
  apiFailures: Array<{ method: string; url: string; status: number; at: string; code?: string }>
  images: string[]
  status: FeedbackStatus
  adminNote: string
  handledBy: string | null
  handledAt: string | null
  createdAt: string
  updatedAt: string
}

export interface FeedbackList {
  items: FeedbackItem[]
  total: number
  page: number
  pageSize: number
  counts: Record<'all' | FeedbackStatus, number>
}

export const STATUS_ORDER: FeedbackStatus[] = ['new', 'reviewing', 'planned', 'fixed', 'rejected']

export const STATUS_LABEL: Record<FeedbackStatus, string> = {
  new: 'Mới',
  reviewing: 'Đang xem',
  planned: 'Đã lên kế hoạch',
  fixed: 'Đã sửa',
  rejected: 'Từ chối',
}

export const TYPE_LABEL: Record<FeedbackKind, string> = {
  bug: '🐞 Báo lỗi',
  idea: '💡 Góp ý',
  feature: '✨ Order tính năng',
  other: 'Khác',
}

/** Màu chữ + nền của nhãn trạng thái (Tailwind). */
export const STATUS_TONE: Record<FeedbackStatus, string> = {
  new: 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300',
  reviewing: 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300',
  planned: 'bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300',
  fixed: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
  rejected: 'bg-muted text-muted-foreground',
}

/** Số trên chấm đỏ ở menu: 0 → không hiện; > 99 → "99+". */
export function unreadBadge(n: number | undefined | null): string | null {
  if (!n || n <= 0) return null
  return n > 99 ? '99+' : String(n)
}

/** Trích dẫn đầu nội dung cho cột danh sách (một đoạn ngắn, bỏ xuống dòng). */
export function snippet(message: string, max = 120): string {
  const one = message.replace(/\s+/g, ' ').trim()
  return one.length > max ? `${one.slice(0, max - 1)}…` : one
}
